import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import { nl } from 'vuetify/locale';

const lockinLight = {
  dark: false,
  colors: {
    background:      '#D7EEFB',
    surface:         '#FFFFFF',
    primary:         '#1FA8F2',
    'primary-darken-1': '#0E7DBE',
    secondary:       '#3BC4B5',
    'secondary-darken-1': '#249E91',
    error:           '#EF4444',
    info:            '#1FA8F2',
    success:         '#10B981',
    warning:         '#F59E0B',
    'on-primary':    '#FFFFFF',
    'on-secondary':  '#FFFFFF',
    'on-background': '#0F1F2E',
    'on-surface':    '#0F1F2E',
  },
};

export const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'lockinLight',
    themes: { lockinLight },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
  locale: {
    locale: 'nl',
    fallback: 'nl',
    messages: { nl },
  },
  defaults: {
    VBtn:  { rounded: 'lg', class: 'text-none' },
    VCard: { rounded: 'lg' },
    VTextField:  { variant: 'outlined', density: 'comfortable' },
    VSelect:     { variant: 'outlined', density: 'comfortable' },
    VTextarea:   { variant: 'outlined', density: 'comfortable' },
  },
});
